// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/modality/v1/types.proto (package creativefabrica.modality.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldValue, FieldValueJson, Modality, ModalityJson, OutputType, OutputTypeJson } from "@repo/rpc-types-creativefabrica-preset-v1";
import { file_creativefabrica_preset_v1_types } from "@repo/rpc-types-creativefabrica-preset-v1";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/modality/v1/types.proto.
 */
export const file_creativefabrica_modality_v1_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_preset_v1_types, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * InputFile describes a media file provided in the generate request.
 *
 * @generated from message creativefabrica.modality.v1.InputFile
 */
export type InputFile = Message<"creativefabrica.modality.v1.InputFile"> & {
  /**
   * e.g. "portrait.jpg"
   *
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * size in bytes
   *
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;

  /**
   * optional: when set, server fetches from this URL; when empty, server returns a pre-signed upload URL
   *
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * Role this file fills for role-keyed modalities (media_to_video).
   * e.g. "firstFrame", "lastFrame", "referenceImage", "referenceAudio", "referenceVideo".
   * Absent for flat-file modalities (image_to_image etc.).
   *
   * @generated from field: optional string role = 4;
   */
  role?: string | undefined;

  /**
   * Placeholder name used in the prompt as {{alias}} for reference* roles.
   * Never set for frame roles (firstFrame, lastFrame) — those bind structurally.
   *
   * @generated from field: optional string alias = 5;
   */
  alias?: string | undefined;

  /**
   * Client-asserted file metadata used for pre-upload validation and coin
   * reservation. Server cross-checks every set field against pipeline-probed
   * values at upload-completion and fails the generation on mismatch.
   *
   * @generated from field: optional creativefabrica.modality.v1.InputFile.InputFileMetadata metadata = 6;
   */
  metadata?: InputFile_InputFileMetadata | undefined;

  /**
   * Provider routing metadata: per-file, per-role typed input parameters, keyed
   * by property name (e.g. {"reference_type": "background"} for PixVerse C1).
   * Values reuse the same FieldValue/FieldDescriptor system as the model's
   * options, so a value may be a string, integer, float, boolean, array or
   * object — not just a string. The accepted keys and their types / allowed
   * values / defaults are declared per role in the model registry (models.yaml)
   * and surfaced via RoleConstraint.provider_metadata; the server validates
   * these pairs against that declaration, applies declared defaults for absent
   * keys, and passes them to the provider. Distinct from `metadata` above, which
   * is probe-checked media dimensions.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> provider_metadata = 7;
   */
  providerMetadata: { [key: string]: FieldValue };
};

/**
 * InputFile describes a media file provided in the generate request.
 *
 * @generated from message creativefabrica.modality.v1.InputFile
 */
export type InputFileJson = {
  /**
   * e.g. "portrait.jpg"
   *
   * @generated from field: string file_name = 1;
   */
  fileName?: string;

  /**
   * size in bytes
   *
   * @generated from field: int64 file_size = 2;
   */
  fileSize?: string;

  /**
   * optional: when set, server fetches from this URL; when empty, server returns a pre-signed upload URL
   *
   * @generated from field: string url = 3;
   */
  url?: string;

  /**
   * Role this file fills for role-keyed modalities (media_to_video).
   * e.g. "firstFrame", "lastFrame", "referenceImage", "referenceAudio", "referenceVideo".
   * Absent for flat-file modalities (image_to_image etc.).
   *
   * @generated from field: optional string role = 4;
   */
  role?: string;

  /**
   * Placeholder name used in the prompt as {{alias}} for reference* roles.
   * Never set for frame roles (firstFrame, lastFrame) — those bind structurally.
   *
   * @generated from field: optional string alias = 5;
   */
  alias?: string;

  /**
   * Client-asserted file metadata used for pre-upload validation and coin
   * reservation. Server cross-checks every set field against pipeline-probed
   * values at upload-completion and fails the generation on mismatch.
   *
   * @generated from field: optional creativefabrica.modality.v1.InputFile.InputFileMetadata metadata = 6;
   */
  metadata?: InputFile_InputFileMetadataJson;

  /**
   * Provider routing metadata: per-file, per-role typed input parameters, keyed
   * by property name (e.g. {"reference_type": "background"} for PixVerse C1).
   * Values reuse the same FieldValue/FieldDescriptor system as the model's
   * options, so a value may be a string, integer, float, boolean, array or
   * object — not just a string. The accepted keys and their types / allowed
   * values / defaults are declared per role in the model registry (models.yaml)
   * and surfaced via RoleConstraint.provider_metadata; the server validates
   * these pairs against that declaration, applies declared defaults for absent
   * keys, and passes them to the provider. Distinct from `metadata` above, which
   * is probe-checked media dimensions.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> provider_metadata = 7;
   */
  providerMetadata?: { [key: string]: FieldValueJson };
};

/**
 * Describes the message creativefabrica.modality.v1.InputFile.
 * Use `create(InputFileSchema)` to create a new message.
 */
export const InputFileSchema: GenMessage<InputFile, {jsonType: InputFileJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 0);

/**
 * @generated from message creativefabrica.modality.v1.InputFile.InputFileMetadata
 */
export type InputFile_InputFileMetadata = Message<"creativefabrica.modality.v1.InputFile.InputFileMetadata"> & {
  /**
   * @generated from field: optional int32 duration_seconds = 1;
   */
  durationSeconds?: number | undefined;

  /**
   * @generated from field: optional int32 width = 2;
   */
  width?: number | undefined;

  /**
   * @generated from field: optional int32 height = 3;
   */
  height?: number | undefined;

  /**
   * Frame rate rounded to the nearest integer (23.976 -> 24, 29.97 -> 30).
   * Read by models whose price depends on the source frame rate (e.g. the
   * BytePlus enhance models when `fps` is left at 0 = keep source) so the
   * reserve-before-upload path can price exactly; cross-checked against
   * the probe once the upload lands, like the other axes.
   *
   * @generated from field: optional int32 fps = 4;
   */
  fps?: number | undefined;
};

/**
 * @generated from message creativefabrica.modality.v1.InputFile.InputFileMetadata
 */
export type InputFile_InputFileMetadataJson = {
  /**
   * @generated from field: optional int32 duration_seconds = 1;
   */
  durationSeconds?: number;

  /**
   * @generated from field: optional int32 width = 2;
   */
  width?: number;

  /**
   * @generated from field: optional int32 height = 3;
   */
  height?: number;

  /**
   * Frame rate rounded to the nearest integer (23.976 -> 24, 29.97 -> 30).
   * Read by models whose price depends on the source frame rate (e.g. the
   * BytePlus enhance models when `fps` is left at 0 = keep source) so the
   * reserve-before-upload path can price exactly; cross-checked against
   * the probe once the upload lands, like the other axes.
   *
   * @generated from field: optional int32 fps = 4;
   */
  fps?: number;
};

/**
 * Describes the message creativefabrica.modality.v1.InputFile.InputFileMetadata.
 * Use `create(InputFile_InputFileMetadataSchema)` to create a new message.
 */
export const InputFile_InputFileMetadataSchema: GenMessage<InputFile_InputFileMetadata, {jsonType: InputFile_InputFileMetadataJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 0, 0);

/**
 * UploadURL is a pre-signed S3 URL returned for files that need client-side upload.
 *
 * @generated from message creativefabrica.modality.v1.UploadURL
 */
export type UploadURL = Message<"creativefabrica.modality.v1.UploadURL"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: string presigned_url = 3;
   */
  presignedUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * UploadURL is a pre-signed S3 URL returned for files that need client-side upload.
 *
 * @generated from message creativefabrica.modality.v1.UploadURL
 */
export type UploadURLJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;

  /**
   * @generated from field: string presigned_url = 3;
   */
  presignedUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.modality.v1.UploadURL.
 * Use `create(UploadURLSchema)` to create a new message.
 */
export const UploadURLSchema: GenMessage<UploadURL, {jsonType: UploadURLJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 1);

/**
 * OutputMedia represents a single output item produced by a generation.
 *
 * @generated from message creativefabrica.modality.v1.OutputMedia
 */
export type OutputMedia = Message<"creativefabrica.modality.v1.OutputMedia"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: creativefabrica.modality.v1.MediaType media_type = 2;
   */
  mediaType: MediaType;

  /**
   * @generated from field: creativefabrica.modality.v1.MediaStatus status = 3;
   */
  status: MediaStatus;

  /**
   * @generated from field: string failure_reason = 4;
   */
  failureReason: string;

  /**
   * @generated from field: bool is_nsfw = 10;
   */
  isNsfw: boolean;

  /**
   * Type-specific content — exactly one is set based on media_type
   *
   * @generated from oneof creativefabrica.modality.v1.OutputMedia.content
   */
  content: {
    /**
     * @generated from field: creativefabrica.modality.v1.ImageOutputContent image_content = 5;
     */
    value: ImageOutputContent;
    case: "imageContent";
  } | {
    /**
     * @generated from field: creativefabrica.modality.v1.AudioOutputContent audio_content = 6;
     */
    value: AudioOutputContent;
    case: "audioContent";
  } | {
    /**
     * @generated from field: creativefabrica.modality.v1.VideoOutputContent video_content = 7;
     */
    value: VideoOutputContent;
    case: "videoContent";
  } | {
    /**
     * @generated from field: creativefabrica.modality.v1.CadOutputContent cad_content = 8;
     */
    value: CadOutputContent;
    case: "cadContent";
  } | {
    /**
     * @generated from field: creativefabrica.modality.v1.TextOutputContent text_content = 9;
     */
    value: TextOutputContent;
    case: "textContent";
  } | {
    /**
     * @generated from field: creativefabrica.modality.v1.LayeredImageOutputContent layered_image_content = 11;
     */
    value: LayeredImageOutputContent;
    case: "layeredImageContent";
  } | { case: undefined; value?: undefined };
};

/**
 * OutputMedia represents a single output item produced by a generation.
 *
 * @generated from message creativefabrica.modality.v1.OutputMedia
 */
export type OutputMediaJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: creativefabrica.modality.v1.MediaType media_type = 2;
   */
  mediaType?: MediaTypeJson;

  /**
   * @generated from field: creativefabrica.modality.v1.MediaStatus status = 3;
   */
  status?: MediaStatusJson;

  /**
   * @generated from field: string failure_reason = 4;
   */
  failureReason?: string;

  /**
   * @generated from field: bool is_nsfw = 10;
   */
  isNsfw?: boolean;

  /**
   * @generated from field: creativefabrica.modality.v1.ImageOutputContent image_content = 5;
   */
  imageContent?: ImageOutputContentJson;

  /**
   * @generated from field: creativefabrica.modality.v1.AudioOutputContent audio_content = 6;
   */
  audioContent?: AudioOutputContentJson;

  /**
   * @generated from field: creativefabrica.modality.v1.VideoOutputContent video_content = 7;
   */
  videoContent?: VideoOutputContentJson;

  /**
   * @generated from field: creativefabrica.modality.v1.CadOutputContent cad_content = 8;
   */
  cadContent?: CadOutputContentJson;

  /**
   * @generated from field: creativefabrica.modality.v1.TextOutputContent text_content = 9;
   */
  textContent?: TextOutputContentJson;

  /**
   * @generated from field: creativefabrica.modality.v1.LayeredImageOutputContent layered_image_content = 11;
   */
  layeredImageContent?: LayeredImageOutputContentJson;
};

/**
 * Describes the message creativefabrica.modality.v1.OutputMedia.
 * Use `create(OutputMediaSchema)` to create a new message.
 */
export const OutputMediaSchema: GenMessage<OutputMedia, {jsonType: OutputMediaJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 2);

/**
 * @generated from message creativefabrica.modality.v1.InputMedia
 */
export type InputMedia = Message<"creativefabrica.modality.v1.InputMedia"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize: bigint;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType: string;

  /**
   * S3 URL, populated after upload/copy
   *
   * @generated from field: string url = 5;
   */
  url: string;

  /**
   * UPLOAD or URL (existing enum)
   *
   * @generated from field: creativefabrica.modality.v1.InputMediaSource source_type = 6;
   */
  sourceType: InputMediaSource;

  /**
   * @generated from field: creativefabrica.modality.v1.InputMediaStatus status = 7;
   */
  status: InputMediaStatus;

  /**
   * Role this media fills for role-keyed modalities — mirrors InputFile.role.
   *
   * @generated from field: optional string role = 8;
   */
  role?: string | undefined;

  /**
   * Prompt placeholder alias for reference* roles — mirrors InputFile.alias.
   *
   * @generated from field: optional string alias = 9;
   */
  alias?: string | undefined;
};

/**
 * @generated from message creativefabrica.modality.v1.InputMedia
 */
export type InputMediaJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize?: string;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType?: string;

  /**
   * S3 URL, populated after upload/copy
   *
   * @generated from field: string url = 5;
   */
  url?: string;

  /**
   * UPLOAD or URL (existing enum)
   *
   * @generated from field: creativefabrica.modality.v1.InputMediaSource source_type = 6;
   */
  sourceType?: InputMediaSourceJson;

  /**
   * @generated from field: creativefabrica.modality.v1.InputMediaStatus status = 7;
   */
  status?: InputMediaStatusJson;

  /**
   * Role this media fills for role-keyed modalities — mirrors InputFile.role.
   *
   * @generated from field: optional string role = 8;
   */
  role?: string;

  /**
   * Prompt placeholder alias for reference* roles — mirrors InputFile.alias.
   *
   * @generated from field: optional string alias = 9;
   */
  alias?: string;
};

/**
 * Describes the message creativefabrica.modality.v1.InputMedia.
 * Use `create(InputMediaSchema)` to create a new message.
 */
export const InputMediaSchema: GenMessage<InputMedia, {jsonType: InputMediaJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 3);

/**
 * ThumbnailVariant represents a single thumbnail at a specific width.
 *
 * @generated from message creativefabrica.modality.v1.ThumbnailVariant
 */
export type ThumbnailVariant = Message<"creativefabrica.modality.v1.ThumbnailVariant"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: int32 width = 2;
   */
  width: number;
};

/**
 * ThumbnailVariant represents a single thumbnail at a specific width.
 *
 * @generated from message creativefabrica.modality.v1.ThumbnailVariant
 */
export type ThumbnailVariantJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: int32 width = 2;
   */
  width?: number;
};

/**
 * Describes the message creativefabrica.modality.v1.ThumbnailVariant.
 * Use `create(ThumbnailVariantSchema)` to create a new message.
 */
export const ThumbnailVariantSchema: GenMessage<ThumbnailVariant, {jsonType: ThumbnailVariantJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 4);

/**
 * ImageOutputContent — aligns with session_images table fields.
 *
 * @generated from message creativefabrica.modality.v1.ImageOutputContent
 */
export type ImageOutputContent = Message<"creativefabrica.modality.v1.ImageOutputContent"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: repeated creativefabrica.modality.v1.ThumbnailVariant thumbnail_urls = 2;
   */
  thumbnailUrls: ThumbnailVariant[];

  /**
   * @generated from field: string preview_url = 3;
   */
  previewUrl: string;

  /**
   * @generated from field: string original_image_url = 4;
   */
  originalImageUrl: string;

  /**
   * @generated from field: string original_preview_url = 5;
   */
  originalPreviewUrl: string;

  /**
   * @generated from field: string file_name = 6;
   */
  fileName: string;

  /**
   * @generated from field: string mime_type = 7;
   */
  mimeType: string;

  /**
   * @generated from field: int32 width = 8;
   */
  width: number;

  /**
   * @generated from field: int32 height = 9;
   */
  height: number;
};

/**
 * ImageOutputContent — aligns with session_images table fields.
 *
 * @generated from message creativefabrica.modality.v1.ImageOutputContent
 */
export type ImageOutputContentJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: repeated creativefabrica.modality.v1.ThumbnailVariant thumbnail_urls = 2;
   */
  thumbnailUrls?: ThumbnailVariantJson[];

  /**
   * @generated from field: string preview_url = 3;
   */
  previewUrl?: string;

  /**
   * @generated from field: string original_image_url = 4;
   */
  originalImageUrl?: string;

  /**
   * @generated from field: string original_preview_url = 5;
   */
  originalPreviewUrl?: string;

  /**
   * @generated from field: string file_name = 6;
   */
  fileName?: string;

  /**
   * @generated from field: string mime_type = 7;
   */
  mimeType?: string;

  /**
   * @generated from field: int32 width = 8;
   */
  width?: number;

  /**
   * @generated from field: int32 height = 9;
   */
  height?: number;
};

/**
 * Describes the message creativefabrica.modality.v1.ImageOutputContent.
 * Use `create(ImageOutputContentSchema)` to create a new message.
 */
export const ImageOutputContentSchema: GenMessage<ImageOutputContent, {jsonType: ImageOutputContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 5);

/**
 * LayeredImageOutputContent — a layer-decomposed image: one base plate plus an
 * ordered stack of transparent layers positioned on the base canvas. Provider
 * agnostic: any model that produces base + positioned alpha layers emits this.
 *
 * @generated from message creativefabrica.modality.v1.LayeredImageOutputContent
 */
export type LayeredImageOutputContent = Message<"creativefabrica.modality.v1.LayeredImageOutputContent"> & {
  /**
   * Base plate — bottom of the stack (stacking order 0), in the requested
   * output format. Carries the preview and thumbnails for the whole layered
   * output; its width/height define the coordinate space for layer bounding
   * boxes.
   *
   * @generated from field: creativefabrica.modality.v1.ImageOutputContent base_image = 1;
   */
  baseImage?: ImageOutputContent | undefined;

  /**
   * Layers above the base, ascending by stacking_order (1 = directly above
   * the base). Alpha-PNG cutouts positioned on the base canvas.
   *
   * @generated from field: repeated creativefabrica.modality.v1.ImageLayer layers = 2;
   */
  layers: ImageLayer[];
};

/**
 * LayeredImageOutputContent — a layer-decomposed image: one base plate plus an
 * ordered stack of transparent layers positioned on the base canvas. Provider
 * agnostic: any model that produces base + positioned alpha layers emits this.
 *
 * @generated from message creativefabrica.modality.v1.LayeredImageOutputContent
 */
export type LayeredImageOutputContentJson = {
  /**
   * Base plate — bottom of the stack (stacking order 0), in the requested
   * output format. Carries the preview and thumbnails for the whole layered
   * output; its width/height define the coordinate space for layer bounding
   * boxes.
   *
   * @generated from field: creativefabrica.modality.v1.ImageOutputContent base_image = 1;
   */
  baseImage?: ImageOutputContentJson;

  /**
   * Layers above the base, ascending by stacking_order (1 = directly above
   * the base). Alpha-PNG cutouts positioned on the base canvas.
   *
   * @generated from field: repeated creativefabrica.modality.v1.ImageLayer layers = 2;
   */
  layers?: ImageLayerJson[];
};

/**
 * Describes the message creativefabrica.modality.v1.LayeredImageOutputContent.
 * Use `create(LayeredImageOutputContentSchema)` to create a new message.
 */
export const LayeredImageOutputContentSchema: GenMessage<LayeredImageOutputContent, {jsonType: LayeredImageOutputContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 6);

/**
 * ImageLayer is one transparent layer of a layered image.
 *
 * @generated from message creativefabrica.modality.v1.ImageLayer
 */
export type ImageLayer = Message<"creativefabrica.modality.v1.ImageLayer"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * image/png with alpha
   *
   * @generated from field: string mime_type = 3;
   */
  mimeType: string;

  /**
   * layer bitmap dimensions in px (may exceed its bounding box; scale to fit when compositing)
   *
   * @generated from field: int32 width = 4;
   */
  width: number;

  /**
   * @generated from field: int32 height = 5;
   */
  height: number;

  /**
   * 1..N above the base (the base is 0)
   *
   * @generated from field: int32 stacking_order = 6;
   */
  stackingOrder: number;

  /**
   * @generated from field: creativefabrica.modality.v1.LayerBoundingBox bounding_box = 7;
   */
  boundingBox?: LayerBoundingBox | undefined;

  /**
   * provider-supplied label; language not guaranteed
   *
   * @generated from field: string name = 8;
   */
  name: string;

  /**
   * provider-supplied description; language not guaranteed
   *
   * @generated from field: string description = 9;
   */
  description: string;
};

/**
 * ImageLayer is one transparent layer of a layered image.
 *
 * @generated from message creativefabrica.modality.v1.ImageLayer
 */
export type ImageLayerJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;

  /**
   * image/png with alpha
   *
   * @generated from field: string mime_type = 3;
   */
  mimeType?: string;

  /**
   * layer bitmap dimensions in px (may exceed its bounding box; scale to fit when compositing)
   *
   * @generated from field: int32 width = 4;
   */
  width?: number;

  /**
   * @generated from field: int32 height = 5;
   */
  height?: number;

  /**
   * 1..N above the base (the base is 0)
   *
   * @generated from field: int32 stacking_order = 6;
   */
  stackingOrder?: number;

  /**
   * @generated from field: creativefabrica.modality.v1.LayerBoundingBox bounding_box = 7;
   */
  boundingBox?: LayerBoundingBoxJson;

  /**
   * provider-supplied label; language not guaranteed
   *
   * @generated from field: string name = 8;
   */
  name?: string;

  /**
   * provider-supplied description; language not guaranteed
   *
   * @generated from field: string description = 9;
   */
  description?: string;
};

/**
 * Describes the message creativefabrica.modality.v1.ImageLayer.
 * Use `create(ImageLayerSchema)` to create a new message.
 */
export const ImageLayerSchema: GenMessage<ImageLayer, {jsonType: ImageLayerJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 7);

/**
 * LayerBoundingBox is the layer's placement on the base plate, in base-image
 * pixel coordinates, origin top-left.
 *
 * @generated from message creativefabrica.modality.v1.LayerBoundingBox
 */
export type LayerBoundingBox = Message<"creativefabrica.modality.v1.LayerBoundingBox"> & {
  /**
   * @generated from field: int32 left = 1;
   */
  left: number;

  /**
   * @generated from field: int32 top = 2;
   */
  top: number;

  /**
   * @generated from field: int32 right = 3;
   */
  right: number;

  /**
   * @generated from field: int32 bottom = 4;
   */
  bottom: number;
};

/**
 * LayerBoundingBox is the layer's placement on the base plate, in base-image
 * pixel coordinates, origin top-left.
 *
 * @generated from message creativefabrica.modality.v1.LayerBoundingBox
 */
export type LayerBoundingBoxJson = {
  /**
   * @generated from field: int32 left = 1;
   */
  left?: number;

  /**
   * @generated from field: int32 top = 2;
   */
  top?: number;

  /**
   * @generated from field: int32 right = 3;
   */
  right?: number;

  /**
   * @generated from field: int32 bottom = 4;
   */
  bottom?: number;
};

/**
 * Describes the message creativefabrica.modality.v1.LayerBoundingBox.
 * Use `create(LayerBoundingBoxSchema)` to create a new message.
 */
export const LayerBoundingBoxSchema: GenMessage<LayerBoundingBox, {jsonType: LayerBoundingBoxJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 8);

/**
 * AudioOutputContent — aligns with MediaAudioContent.
 *
 * @generated from message creativefabrica.modality.v1.AudioOutputContent
 */
export type AudioOutputContent = Message<"creativefabrica.modality.v1.AudioOutputContent"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string cover_image_url = 2;
   */
  coverImageUrl: string;

  /**
   * @generated from field: repeated creativefabrica.modality.v1.ThumbnailVariant cover_thumbnail_urls = 3;
   */
  coverThumbnailUrls: ThumbnailVariant[];

  /**
   * @generated from field: string file_name = 4;
   */
  fileName: string;

  /**
   * @generated from field: string mime_type = 5;
   */
  mimeType: string;

  /**
   * Playback length rounded to whole seconds. Kept for existing clients;
   * prefer duration_seconds_exact where sub-second accuracy matters.
   *
   * @generated from field: int32 duration_seconds = 6;
   */
  durationSeconds: number;

  /**
   * Size of the audio file in bytes.
   *
   * @generated from field: int64 file_size = 7;
   */
  fileSize: bigint;

  /**
   * Exact playback length. Audio models are billed per second of output, so
   * whole seconds are too coarse to reconcile a charge against: a clip billed
   * as 31.4s would otherwise report 31.
   *
   * @generated from field: double duration_seconds_exact = 8;
   */
  durationSecondsExact: number;
};

/**
 * AudioOutputContent — aligns with MediaAudioContent.
 *
 * @generated from message creativefabrica.modality.v1.AudioOutputContent
 */
export type AudioOutputContentJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: string cover_image_url = 2;
   */
  coverImageUrl?: string;

  /**
   * @generated from field: repeated creativefabrica.modality.v1.ThumbnailVariant cover_thumbnail_urls = 3;
   */
  coverThumbnailUrls?: ThumbnailVariantJson[];

  /**
   * @generated from field: string file_name = 4;
   */
  fileName?: string;

  /**
   * @generated from field: string mime_type = 5;
   */
  mimeType?: string;

  /**
   * Playback length rounded to whole seconds. Kept for existing clients;
   * prefer duration_seconds_exact where sub-second accuracy matters.
   *
   * @generated from field: int32 duration_seconds = 6;
   */
  durationSeconds?: number;

  /**
   * Size of the audio file in bytes.
   *
   * @generated from field: int64 file_size = 7;
   */
  fileSize?: string;

  /**
   * Exact playback length. Audio models are billed per second of output, so
   * whole seconds are too coarse to reconcile a charge against: a clip billed
   * as 31.4s would otherwise report 31.
   *
   * @generated from field: double duration_seconds_exact = 8;
   */
  durationSecondsExact?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message creativefabrica.modality.v1.AudioOutputContent.
 * Use `create(AudioOutputContentSchema)` to create a new message.
 */
export const AudioOutputContentSchema: GenMessage<AudioOutputContent, {jsonType: AudioOutputContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 9);

/**
 * VideoOutputContent — aligns with MediaContentVideo.
 *
 * @generated from message creativefabrica.modality.v1.VideoOutputContent
 */
export type VideoOutputContent = Message<"creativefabrica.modality.v1.VideoOutputContent"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: repeated creativefabrica.modality.v1.ThumbnailVariant thumbnail_urls = 2;
   */
  thumbnailUrls: ThumbnailVariant[];

  /**
   * @generated from field: string preview_url = 3;
   */
  previewUrl: string;

  /**
   * @generated from field: string original_video_url = 4;
   */
  originalVideoUrl: string;

  /**
   * @generated from field: repeated string hls_urls = 5;
   */
  hlsUrls: string[];

  /**
   * @generated from field: repeated string dash_urls = 6;
   */
  dashUrls: string[];

  /**
   * @generated from field: string file_name = 7;
   */
  fileName: string;

  /**
   * @generated from field: string mime_type = 8;
   */
  mimeType: string;

  /**
   * @generated from field: int32 duration_seconds = 9;
   */
  durationSeconds: number;

  /**
   * @generated from field: string aspect_ratio = 10;
   */
  aspectRatio: string;

  /**
   * @generated from field: int32 width = 11;
   */
  width: number;

  /**
   * @generated from field: int32 height = 12;
   */
  height: number;

  /**
   * Evenly spaced frame captures spanning the whole video, first to last, for
   * timeline scrubbing. Present only for models that request a filmstrip.
   *
   * @generated from field: repeated string filmstrip_urls = 13;
   */
  filmstripUrls: string[];
};

/**
 * VideoOutputContent — aligns with MediaContentVideo.
 *
 * @generated from message creativefabrica.modality.v1.VideoOutputContent
 */
export type VideoOutputContentJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: repeated creativefabrica.modality.v1.ThumbnailVariant thumbnail_urls = 2;
   */
  thumbnailUrls?: ThumbnailVariantJson[];

  /**
   * @generated from field: string preview_url = 3;
   */
  previewUrl?: string;

  /**
   * @generated from field: string original_video_url = 4;
   */
  originalVideoUrl?: string;

  /**
   * @generated from field: repeated string hls_urls = 5;
   */
  hlsUrls?: string[];

  /**
   * @generated from field: repeated string dash_urls = 6;
   */
  dashUrls?: string[];

  /**
   * @generated from field: string file_name = 7;
   */
  fileName?: string;

  /**
   * @generated from field: string mime_type = 8;
   */
  mimeType?: string;

  /**
   * @generated from field: int32 duration_seconds = 9;
   */
  durationSeconds?: number;

  /**
   * @generated from field: string aspect_ratio = 10;
   */
  aspectRatio?: string;

  /**
   * @generated from field: int32 width = 11;
   */
  width?: number;

  /**
   * @generated from field: int32 height = 12;
   */
  height?: number;

  /**
   * Evenly spaced frame captures spanning the whole video, first to last, for
   * timeline scrubbing. Present only for models that request a filmstrip.
   *
   * @generated from field: repeated string filmstrip_urls = 13;
   */
  filmstripUrls?: string[];
};

/**
 * Describes the message creativefabrica.modality.v1.VideoOutputContent.
 * Use `create(VideoOutputContentSchema)` to create a new message.
 */
export const VideoOutputContentSchema: GenMessage<VideoOutputContent, {jsonType: VideoOutputContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 10);

/**
 * CadOutputContent — aligns with MediaCADContent.
 *
 * @generated from message creativefabrica.modality.v1.CadOutputContent
 */
export type CadOutputContent = Message<"creativefabrica.modality.v1.CadOutputContent"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: repeated creativefabrica.modality.v1.ThumbnailVariant thumbnail_urls = 2;
   */
  thumbnailUrls: ThumbnailVariant[];

  /**
   * @generated from field: string mime_type = 3;
   */
  mimeType: string;

  /**
   * @generated from field: string source_url = 4;
   */
  sourceUrl: string;

  /**
   * @generated from field: string source_mime_type = 5;
   */
  sourceMimeType: string;
};

/**
 * CadOutputContent — aligns with MediaCADContent.
 *
 * @generated from message creativefabrica.modality.v1.CadOutputContent
 */
export type CadOutputContentJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: repeated creativefabrica.modality.v1.ThumbnailVariant thumbnail_urls = 2;
   */
  thumbnailUrls?: ThumbnailVariantJson[];

  /**
   * @generated from field: string mime_type = 3;
   */
  mimeType?: string;

  /**
   * @generated from field: string source_url = 4;
   */
  sourceUrl?: string;

  /**
   * @generated from field: string source_mime_type = 5;
   */
  sourceMimeType?: string;
};

/**
 * Describes the message creativefabrica.modality.v1.CadOutputContent.
 * Use `create(CadOutputContentSchema)` to create a new message.
 */
export const CadOutputContentSchema: GenMessage<CadOutputContent, {jsonType: CadOutputContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 11);

/**
 * TextOutputContent — aligns with MediaJsonContent + inline data for small responses.
 *
 * @generated from message creativefabrica.modality.v1.TextOutputContent
 */
export type TextOutputContent = Message<"creativefabrica.modality.v1.TextOutputContent"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType: string;

  /**
   * inline structured data (for small responses)
   *
   * @generated from field: google.protobuf.Struct data = 3;
   */
  data?: JsonObject | undefined;
};

/**
 * TextOutputContent — aligns with MediaJsonContent + inline data for small responses.
 *
 * @generated from message creativefabrica.modality.v1.TextOutputContent
 */
export type TextOutputContentJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType?: string;

  /**
   * inline structured data (for small responses)
   *
   * @generated from field: google.protobuf.Struct data = 3;
   */
  data?: StructJson;
};

/**
 * Describes the message creativefabrica.modality.v1.TextOutputContent.
 * Use `create(TextOutputContentSchema)` to create a new message.
 */
export const TextOutputContentSchema: GenMessage<TextOutputContent, {jsonType: TextOutputContentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 12);

/**
 * GenerationError is returned when a generation fails.
 *
 * @generated from message creativefabrica.modality.v1.GenerationError
 */
export type GenerationError = Message<"creativefabrica.modality.v1.GenerationError"> & {
  /**
   * e.g. "PROVIDER_ERROR", "VALIDATION_ERROR", "INSUFFICIENT_COINS"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * GenerationError is returned when a generation fails.
 *
 * @generated from message creativefabrica.modality.v1.GenerationError
 */
export type GenerationErrorJson = {
  /**
   * e.g. "PROVIDER_ERROR", "VALIDATION_ERROR", "INSUFFICIENT_COINS"
   *
   * @generated from field: string code = 1;
   */
  code?: string;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message creativefabrica.modality.v1.GenerationError.
 * Use `create(GenerationErrorSchema)` to create a new message.
 */
export const GenerationErrorSchema: GenMessage<GenerationError, {jsonType: GenerationErrorJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 13);

/**
 * @generated from message creativefabrica.modality.v1.Generation
 */
export type Generation = Message<"creativefabrica.modality.v1.Generation"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: creativefabrica.modality.v1.GenerationStatus status = 2;
   */
  status: GenerationStatus;

  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 3;
   */
  modality: Modality;

  /**
   * @generated from field: creativefabrica.preset.v1.OutputType output_type = 4;
   */
  outputType: OutputType;

  /**
   * empty for direct generations
   *
   * @generated from field: string preset_id = 5;
   */
  presetId: string;

  /**
   * 0 for direct generations
   *
   * @generated from field: int32 preset_version = 6;
   */
  presetVersion: number;

  /**
   * @generated from field: string model_used = 7;
   */
  modelUsed: string;

  /**
   * @generated from field: string provider_used = 8;
   */
  providerUsed: string;

  /**
   * populated when COMPLETED
   *
   * @generated from field: repeated creativefabrica.modality.v1.OutputMedia output_media = 9;
   */
  outputMedia: OutputMedia[];

  /**
   * input files used for this generation
   *
   * @generated from field: repeated creativefabrica.modality.v1.InputMedia input_media = 10;
   */
  inputMedia: InputMedia[];

  /**
   * 0.0–1.0, best-effort while PROCESSING
   *
   * @generated from field: double progress = 11;
   */
  progress: number;

  /**
   * populated when FAILED
   *
   * @generated from field: creativefabrica.modality.v1.GenerationError error = 12;
   */
  error?: GenerationError | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp | undefined;

  /**
   * set when COMPLETED
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 14;
   */
  completedAt?: Timestamp | undefined;

  /**
   * set when FAILED
   *
   * @generated from field: google.protobuf.Timestamp failed_at = 15;
   */
  failedAt?: Timestamp | undefined;

  /**
   * user-provided template variables (preset-based only)
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> prompt_variables = 18;
   */
  promptVariables: { [key: string]: FieldValue };

  /**
   * validated options used for generation
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> options = 19;
   */
  options: { [key: string]: FieldValue };

  /**
   * client-provided opaque metadata
   *
   * @generated from field: map<string, string> metadata = 20;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: string user_id = 21;
   */
  userId: string;

  /**
   * populated when the generation was created via GenerateFromTemplate, empty otherwise
   *
   * @generated from field: string template_id = 22;
   */
  templateId: string;

  /**
   * the template revision the generation resolved, empty for non-template generations
   *
   * @generated from field: string template_revision_id = 23;
   */
  templateRevisionId: string;
};

/**
 * @generated from message creativefabrica.modality.v1.Generation
 */
export type GenerationJson = {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId?: string;

  /**
   * @generated from field: creativefabrica.modality.v1.GenerationStatus status = 2;
   */
  status?: GenerationStatusJson;

  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 3;
   */
  modality?: ModalityJson;

  /**
   * @generated from field: creativefabrica.preset.v1.OutputType output_type = 4;
   */
  outputType?: OutputTypeJson;

  /**
   * empty for direct generations
   *
   * @generated from field: string preset_id = 5;
   */
  presetId?: string;

  /**
   * 0 for direct generations
   *
   * @generated from field: int32 preset_version = 6;
   */
  presetVersion?: number;

  /**
   * @generated from field: string model_used = 7;
   */
  modelUsed?: string;

  /**
   * @generated from field: string provider_used = 8;
   */
  providerUsed?: string;

  /**
   * populated when COMPLETED
   *
   * @generated from field: repeated creativefabrica.modality.v1.OutputMedia output_media = 9;
   */
  outputMedia?: OutputMediaJson[];

  /**
   * input files used for this generation
   *
   * @generated from field: repeated creativefabrica.modality.v1.InputMedia input_media = 10;
   */
  inputMedia?: InputMediaJson[];

  /**
   * 0.0–1.0, best-effort while PROCESSING
   *
   * @generated from field: double progress = 11;
   */
  progress?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * populated when FAILED
   *
   * @generated from field: creativefabrica.modality.v1.GenerationError error = 12;
   */
  error?: GenerationErrorJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: TimestampJson;

  /**
   * set when COMPLETED
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 14;
   */
  completedAt?: TimestampJson;

  /**
   * set when FAILED
   *
   * @generated from field: google.protobuf.Timestamp failed_at = 15;
   */
  failedAt?: TimestampJson;

  /**
   * user-provided template variables (preset-based only)
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> prompt_variables = 18;
   */
  promptVariables?: { [key: string]: FieldValueJson };

  /**
   * validated options used for generation
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> options = 19;
   */
  options?: { [key: string]: FieldValueJson };

  /**
   * client-provided opaque metadata
   *
   * @generated from field: map<string, string> metadata = 20;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: string user_id = 21;
   */
  userId?: string;

  /**
   * populated when the generation was created via GenerateFromTemplate, empty otherwise
   *
   * @generated from field: string template_id = 22;
   */
  templateId?: string;

  /**
   * the template revision the generation resolved, empty for non-template generations
   *
   * @generated from field: string template_revision_id = 23;
   */
  templateRevisionId?: string;
};

/**
 * Describes the message creativefabrica.modality.v1.Generation.
 * Use `create(GenerationSchema)` to create a new message.
 */
export const GenerationSchema: GenMessage<Generation, {jsonType: GenerationJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_modality_v1_types, 14);

/**
 * GenerationStatus tracks the lifecycle of a generation.
 *
 * @generated from enum creativefabrica.modality.v1.GenerationStatus
 */
export enum GenerationStatus {
  /**
   * @generated from enum value: GENERATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * waiting for client to upload files via pre-signed URLs
   *
   * @generated from enum value: GENERATION_STATUS_UPLOAD_PENDING = 1;
   */
  UPLOAD_PENDING = 1,

  /**
   * queued for processing
   *
   * @generated from enum value: GENERATION_STATUS_PENDING = 2;
   */
  PENDING = 2,

  /**
   * provider is working
   *
   * @generated from enum value: GENERATION_STATUS_PROCESSING = 3;
   */
  PROCESSING = 3,

  /**
   * results available in output_media
   *
   * @generated from enum value: GENERATION_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * see error field
   *
   * @generated from enum value: GENERATION_STATUS_FAILED = 5;
   */
  FAILED = 5,

  /**
   * @generated from enum value: GENERATION_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,
}

/**
 * GenerationStatus tracks the lifecycle of a generation.
 *
 * @generated from enum creativefabrica.modality.v1.GenerationStatus
 */
export type GenerationStatusJson = "GENERATION_STATUS_UNSPECIFIED" | "GENERATION_STATUS_UPLOAD_PENDING" | "GENERATION_STATUS_PENDING" | "GENERATION_STATUS_PROCESSING" | "GENERATION_STATUS_COMPLETED" | "GENERATION_STATUS_FAILED" | "GENERATION_STATUS_CANCELLED";

/**
 * Describes the enum creativefabrica.modality.v1.GenerationStatus.
 */
export const GenerationStatusSchema: GenEnum<GenerationStatus, GenerationStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_modality_v1_types, 0);

/**
 * MediaType describes the kind of output media item.
 *
 * @generated from enum creativefabrica.modality.v1.MediaType
 */
export enum MediaType {
  /**
   * @generated from enum value: MEDIA_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEDIA_TYPE_IMAGE = 1;
   */
  IMAGE = 1,

  /**
   * @generated from enum value: MEDIA_TYPE_AUDIO = 2;
   */
  AUDIO = 2,

  /**
   * @generated from enum value: MEDIA_TYPE_VIDEO = 3;
   */
  VIDEO = 3,

  /**
   * @generated from enum value: MEDIA_TYPE_CAD = 4;
   */
  CAD = 4,

  /**
   * @generated from enum value: MEDIA_TYPE_JSON = 5;
   */
  JSON = 5,

  /**
   * one base image plus positioned alpha layers
   *
   * @generated from enum value: MEDIA_TYPE_LAYERED_IMAGE = 6;
   */
  LAYERED_IMAGE = 6,
}

/**
 * MediaType describes the kind of output media item.
 *
 * @generated from enum creativefabrica.modality.v1.MediaType
 */
export type MediaTypeJson = "MEDIA_TYPE_UNSPECIFIED" | "MEDIA_TYPE_IMAGE" | "MEDIA_TYPE_AUDIO" | "MEDIA_TYPE_VIDEO" | "MEDIA_TYPE_CAD" | "MEDIA_TYPE_JSON" | "MEDIA_TYPE_LAYERED_IMAGE";

/**
 * Describes the enum creativefabrica.modality.v1.MediaType.
 */
export const MediaTypeSchema: GenEnum<MediaType, MediaTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_modality_v1_types, 1);

/**
 * MediaStatus tracks the lifecycle of an individual output media item.
 *
 * @generated from enum creativefabrica.modality.v1.MediaStatus
 */
export enum MediaStatus {
  /**
   * @generated from enum value: MEDIA_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEDIA_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: MEDIA_STATUS_PROCESSING = 2;
   */
  PROCESSING = 2,

  /**
   * @generated from enum value: MEDIA_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: MEDIA_STATUS_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * MediaStatus tracks the lifecycle of an individual output media item.
 *
 * @generated from enum creativefabrica.modality.v1.MediaStatus
 */
export type MediaStatusJson = "MEDIA_STATUS_UNSPECIFIED" | "MEDIA_STATUS_PENDING" | "MEDIA_STATUS_PROCESSING" | "MEDIA_STATUS_COMPLETED" | "MEDIA_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.modality.v1.MediaStatus.
 */
export const MediaStatusSchema: GenEnum<MediaStatus, MediaStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_modality_v1_types, 2);

/**
 * InputMediaSource indicates how the input file was provided.
 *
 * @generated from enum creativefabrica.modality.v1.InputMediaSource
 */
export enum InputMediaSource {
  /**
   * @generated from enum value: INPUT_MEDIA_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * client uploads via pre-signed URL
   *
   * @generated from enum value: INPUT_MEDIA_SOURCE_UPLOAD = 1;
   */
  UPLOAD = 1,

  /**
   * server fetches from client-provided URL
   *
   * @generated from enum value: INPUT_MEDIA_SOURCE_URL = 2;
   */
  URL = 2,
}

/**
 * InputMediaSource indicates how the input file was provided.
 *
 * @generated from enum creativefabrica.modality.v1.InputMediaSource
 */
export type InputMediaSourceJson = "INPUT_MEDIA_SOURCE_UNSPECIFIED" | "INPUT_MEDIA_SOURCE_UPLOAD" | "INPUT_MEDIA_SOURCE_URL";

/**
 * Describes the enum creativefabrica.modality.v1.InputMediaSource.
 */
export const InputMediaSourceSchema: GenEnum<InputMediaSource, InputMediaSourceJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_modality_v1_types, 3);

/**
 * @generated from enum creativefabrica.modality.v1.InputMediaStatus
 */
export enum InputMediaStatus {
  /**
   * @generated from enum value: INPUT_MEDIA_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INPUT_MEDIA_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: INPUT_MEDIA_STATUS_UPLOADED = 2;
   */
  UPLOADED = 2,

  /**
   * @generated from enum value: INPUT_MEDIA_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * @generated from enum creativefabrica.modality.v1.InputMediaStatus
 */
export type InputMediaStatusJson = "INPUT_MEDIA_STATUS_UNSPECIFIED" | "INPUT_MEDIA_STATUS_PENDING" | "INPUT_MEDIA_STATUS_UPLOADED" | "INPUT_MEDIA_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.modality.v1.InputMediaStatus.
 */
export const InputMediaStatusSchema: GenEnum<InputMediaStatus, InputMediaStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_modality_v1_types, 4);

